import { Link } from "react-router-dom";

const LOGO = "https://customer-assets.emergentagent.com/job_8a8d0b4b-d26f-4b82-a717-f2ce98e43ad0/artifacts/r7fb2znu_TS%20LOGO.png";

export default function Footer() {
  return (
    <footer className="relative pt-24 pb-28 md:pb-10 border-t border-hair bg-ink-2 overflow-hidden" data-testid="site-footer">
      <div className="max-w-[1600px] mx-auto px-6 md:px-10">
        <div className="grid md:grid-cols-12 gap-10 mb-16">
          <div className="md:col-span-4">
            <img src={LOGO} alt="Toriano Sanzone" className="w-40 opacity-90 mb-6"/>
            <div className="text-hair text-gold mb-3">Leadership · Legacy · Freedom</div>
            <p className="text-bone/60 font-editorial max-w-sm">Master Dog Trainer, founder, author, strategist, and cultural architect — transforming behavior, building leaders.</p>
          </div>

          <div className="md:col-span-2">
            <div className="text-hair text-gold mb-4">Explore</div>
            <ul className="space-y-2 text-bone/70 text-sm">
              <li><Link to="/dog-training" className="hover:text-gold">Dog Training</Link></li>
              <li><Link to="/work-with-toriano?type=business" className="hover:text-gold">Consulting</Link></li>
              <li><Link to="/work-with-toriano?type=ai" className="hover:text-gold">AI Coaching</Link></li>
              <li><Link to="/work-with-toriano?type=event" className="hover:text-gold">Speaking</Link></li>
              <li><Link to="/books-media" className="hover:text-gold">Books & Media</Link></li>
              <li><Link to="/golden-wolf" className="hover:text-gold">Golden Wolf</Link></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="text-hair text-gold mb-4">Reach Toriano</div>
            <ul className="space-y-2 text-bone/70 text-sm">
              <li><a href="tel:3129331528" className="hover:text-gold">312.933.1528 — Call or text</a></li>
              <li><Link to="/contact" className="hover:text-gold">Send an inquiry</Link></li>
              <li>Chicago, Illinois</li>
            </ul>
            <div className="text-hair text-gold mt-6 mb-4">Legal</div>
            <ul className="space-y-2 text-bone/70 text-sm">
              <li><Link to="/privacy" className="hover:text-gold">Privacy</Link></li>
              <li><Link to="/terms" className="hover:text-gold">Terms</Link></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="text-hair text-gold mb-4">Search-visible focus</div>
            <p className="text-bone/50 text-xs leading-relaxed">
              Master Dog Trainer Chicago · Chicago Dog Training · Dog Boot Camp Chicago · Behavioral Dog Training · Service Dog Training Chicago · Puppy Training Chicago · Private Dog Trainer Chicago · Dog Trainer Certification Chicago · Toriano Sanzone Dog Trainer · Wolfkeeper University · AI Consultant Chicago · Business Strategist Chicago · Golden Wolf Foundation
            </p>
          </div>
        </div>

        <div className="hairline mb-6"/>
        <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-hair text-bone/40">
          <div>© {new Date().getFullYear()} Toriano Sanzone. All rights reserved.</div>
          <div className="flex items-center gap-6"><span>Chicago</span><span className="text-gold">✦</span><span>Nairobi</span><span className="text-gold">✦</span><span>The World</span></div>
        </div>
      </div>
    </footer>
  );
}
